import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import App from './App'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import * as serviceWorker from './serviceWorker'
import { configureStore } from "@reduxjs/toolkit"
import rootReducer from './reducers'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { PersistGate } from 'redux-persist/integration/react'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import "./assets/scss/material-kit-react.scss?v=1.8.0"

const persistConfig = {
  key: 'root',
  storage,
}
const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = createStore(persistedReducer, {}, compose(
  applyMiddleware(),
  window.devToolsExtension ? window.devToolsExtension() : f => f,
));

export const persistor = persistStore(store);

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#008000"
    },
    secondary: {
      main: "#000000"
    }
  },
});

function Index(props) {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <MuiThemeProvider theme={theme}>
            <App/>
          </MuiThemeProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  )
}

ReactDOM.render(
  <Index />,
document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
